// Vendor libraries
import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import uuid from 'uuid-random';
import { ToastMessageType } from './toast-messages.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
/**
 * Service to manage creating and removing messages displayed by ToastMessagesComponent.
 */
export class ToastMessagesService {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.messageTypeCss = {
            [ToastMessageType.INFO]: 'toast-black',
            [ToastMessageType.ERROR]: 'toast-error',
            [ToastMessageType.NEUTRAL]: 'toast-neutral',
            [ToastMessageType.SIGNAL]: 'toast-signal',
            [ToastMessageType.SUCCESS]: 'toast-success',
        };
        this.messages = [];
    }
    /**
     * Create a toast message that will be automatically removed in `timeout` seconds.
     * If the timeout is 0, then the message will not be automatically removed.
     */
    addMessage(innerHtml, messageType = ToastMessageType.INFO, timeout = 5000) {
        const id = uuid();
        const message = {
            id,
            innerHtml: this.sanitizer.sanitize(SecurityContext.HTML, innerHtml) || '',
            css: this.messageTypeCss[messageType],
        };
        this.messages = [message, ...this.messages];
        if (timeout > 0) {
            setTimeout(() => {
                this.removeMessage(id);
            }, timeout);
        }
    }
    removeMessage(id) {
        this.messages = this.messages.filter((message) => message.id !== id);
    }
}
ToastMessagesService.ɵfac = function ToastMessagesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastMessagesService)(i0.ɵɵinject(i1.DomSanitizer)); };
ToastMessagesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToastMessagesService, factory: ToastMessagesService.ɵfac });
